module.exports = __webpack_public_path__ + "static/img/wheel.3ea0654.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wheel.png
// module id = hx4f
// module chunks = 0